<div class="core-ui-textarea-form" [class.core-ui-textarea-form--block]="block">
    <div
        class="core-ui-textarea-form__control"
        [class.is-filled]="isFilled"
        [class.is-active]="isFocused"
        [class.is-disabled]="disabled"
        [class.is-readonly]="readOnly"
    >
        <span *ngIf="label" class="core-ui-textarea-form__label">{{ label }}</span>

        <textarea
            class="core-ui-textarea-form__textarea"
            [placeholder]="placeholder"
            [disabled]="disabled"
            [readonly]="readOnly"
            [attr.aria-readonly]="readOnly"
            [attr.rows]="minRows"
            [attr.maxlength]="maxLength"
            [ngStyle]="textareaStyle"
            [value]="value"
            (input)="handleInput($event)"
            (blur)="handleBlur()"
            (focus)="handleFocus()"
            (keydown)="handleKeydown($event)"
        ></textarea>
    </div>
</div>
